module.exports = __webpack_public_path__ + "img/btc.3b4f596c.png";